import { render, staticRenderFns } from "./DragUpdateFile.vue?vue&type=template&id=4946edbc"
import script from "./DragUpdateFile.vue?vue&type=script&lang=js"
export * from "./DragUpdateFile.vue?vue&type=script&lang=js"
import style0 from "./DragUpdateFile.vue?vue&type=style&index=0&id=4946edbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports